import Axios from "axios";
import { resolveApiUrl } from "./apiUrl";

export type ReportType =
  | "VIOLENCE"
  | "SEXUAL"
  | "MINOR_PROTECTION"
  | "BULLYING"
  | "SPAM"
  | "PRIVACY"
  | "PROPERTY"
  | "AGE_CONTENT"
  | "OTHER";

export interface CreateReportRequest {
  conversationId: string;
  reportType: ReportType;
  comment?: string;
}

export async function reportMessage(
  conversationId: string,
  reportType: ReportType,
  comment?: string
): Promise<void> {
  // The env files give this one either absolute or gateway-rooted (it lives on
  // avatar-audit, not avatar-core), so resolve it the same way as every other
  // sibling-service URL. Concatenating REACT_APP_BASE_URL and then stripping
  // "/avatar-core/" produced a doubled host for the absolute spelling.
  const REPORT_URL = resolveApiUrl(process.env.REACT_APP_REPORT_URL);

  const body: CreateReportRequest = {
    conversationId,
    reportType,
  };

  if (comment) {
    body.comment = comment;
  }
  await Axios.post(REPORT_URL, body);
}
